import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import Sidebar from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.facet.lightGray5,
  },
  sidebar: {
    position: 'sticky',
    top: theme.heights.advisorNavigationHeight,
  },
});

const SidebarContent = ({
  className,
  classes,
}) => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  const handleTabChange = tabKey => {
    const [activeTabResource] = pageContentResource.attr('sidebarTabs').resources().list().filter((tabResource) => {
      return tabResource.attr('key') === tabKey;
    });
    loadPageContentLink(activeTabResource?.relationship(fr.relationships.tabData.name).link('related'));
  };

  return (
    <Box className={classNames(classes.root, className)}>
      <Sidebar
        className={classes.sidebar}
        onChange={handleTabChange}
      />
    </Box>
  );
};

SidebarContent.defaultProps = {
  className: '',
};

SidebarContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SidebarContent);
